import React from 'react'
import { IconButton, Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useDeleteStyles = makeStyles((theme) => ({
  root: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
}))

export default (props) => {
  const classes = useDeleteStyles()
  return (
    <IconButton {...props}>
      <Icon className={classes.root}>delete</Icon>
    </IconButton>
  )
}
